import { MoonLoader } from 'react-spinners';

const Loading = ({ loading }: { loading: boolean }) => (
    <div className="loading">
        <MoonLoader loading={loading} />
    </div>
);

export default Loading;
